export default __webpack_public_path__ + "static/media/83.ebb1ee5e.png";